/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useRef, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import PrimeReact from "primereact/api";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";

import { useHistory } from "react-router-dom";
import { useToast } from "../../../hooks/toast";
import api from "../../../services/api";

interface IAttorneyProperties {
  advogado_id: number | null;
  advogado_nome: string;
  advogado_login: string;
  advogado_senha: string;
  advogado_email: string;
  advogado_oab: string;
  advogado_categoria: number;
  advogado_ativo: boolean;
  advogado_nasc: Date;
  advogado_naturalidade: string;
  advogado_end_residencial: string;
  advogado_end_residencial_compl: string;
  advogado_fone_residencial: string;
  advogado_fone_celular: string;
  advogado_conjuge_nome: string;
  advogado_conjuge_nasc: Date;
  permissao_relatoriov: number;
  permissao_relatorioiv: number;
  sta_new_senha: boolean;
  cat_adv: number;
  advogado_valor: string;
  advogado_setor: string;
}

interface IAdministratorProperties {
  administrador_id?: number;
  administrador_nome: string;
  administrador_login: string;
  administrador_senha: string;
  administrador_email: string;
  administrador_categoria: number;
  administrador_ativo: boolean;
  permissao_relatoriov: number;
  permissao_relatorioiv: number;
  sta_new_senha: boolean;
  cat_adm: number;
  valor_adm: string;
  administrador_setor: string;
}

interface IUpdateDateProperties {
  pac_id: number;
  pac_data: Date;
  pac_obs: string;
  advogado_id: number;
  nivel_acesso: string;
  and_arquivo: string;
}

type AgreementUpdateProps = {
  cod: number;
};

const AgreementUpdate: React.FC<AgreementUpdateProps> = ({ cod }) => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyUpdateDate = {
    pac_id: null,
    pac_data: new Date(),
    pac_obs: "",
    advogado_id: 0,
    nivel_acesso: "",
    and_arquivo: "",
  };

  const [updatedates, setUpdateDates] = useState<IUpdateDateProperties[]>([]);
  const [updatedate, setUpdateDate] = useState(emptyUpdateDate);
  const [deleteUpdateDate, setDeleteUpdateDateDialog] = useState(false);
  const [deleteUpdateDatesDialog, setDeleteUpdateDatesDialog] = useState(false);
  const [selectedUpdateDates, setSelectedUpdateDates] = useState<
    IUpdateDateProperties[]
  >([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState("");
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  let loggedUserId = 0;

  const accessData = localStorage.getItem("@Jurisnet:access");

  if (typeof accessData === "string") {
    const access = JSON.parse(accessData);
    loggedUserId = Number(access.usuario_logado);
  }

  useEffect(() => {
    (async () => {
      const response = await api.get(
        `/lawsuits/agreementupdates/show/filtered/${cod}`
      );
      setUpdateDates(response.data);
    })();
  }, [cod]);

  const [attorneys, setAttorneys] = useState<IAttorneyProperties[]>([]);
  const [attorneysOptions, setAttorneysOptions] = useState([{}]);

  useEffect(() => {
    (async () => {
      await api.get("management/attorneys/show/all").then((response) => {
        setAttorneys(response.data);
        response.data.map(
          (attorney: { advogado_id: number; advogado_nome: string }) =>
            // eslint-disable-next-line implicit-arrow-linebreak
            attorneysOptions.push({
              name: attorney.advogado_nome,
              value: attorney.advogado_id,
            })
        );
      });
      attorneysOptions.splice(0, 1);
      setAttorneysOptions(attorneysOptions);
    })();
  }, [attorneysOptions]);

  const [assistants, setAssistants] = useState<IAdministratorProperties[]>([]);
  const [assistantsOptions, setAssistantsOptions] = useState([{}]);

  useEffect(() => {
    (async () => {
      await api.get("management/assistants/show/all").then((response) => {
        setAssistants(response.data);
        response.data.map(
          (assistant: {
            administrador_id: number;
            administrador_nome: string;
          }) =>
            // eslint-disable-next-line implicit-arrow-linebreak
            assistantsOptions.push({
              name: assistant.administrador_nome,
              value: assistant.administrador_id,
            })
        );
      });
      assistantsOptions.splice(0, 1);
      setAssistantsOptions(assistantsOptions);
    })();
  }, [assistantsOptions]);

  const [administrators, setAdministrators] = useState<
    IAdministratorProperties[]
  >([]);

  useEffect(() => {
    (async () => {
      const response = await api.get("/management/administrators/show/all");
      setAdministrators(response.data);
    })();
  }, []);

  const columns = [
    { field: "pac_data", header: "Data", sortable: true },
    { field: "pac_obs", header: "Descrição", sortable: true },
    { field: "advogado_id", header: "Cadastro por", sortable: true },
  ];

  const dateBodyTemplate = (rowData: { pac_data: Date }) => {
    if (updatedates !== undefined) {
      const filteredRecord = updatedates.filter(
        (item) => item.pac_data === rowData.pac_data,
        []
      );

      const dateInput = filteredRecord[0].pac_data?.toString();

      const dateBR = new Date(dateInput);
      const formattedDate = dateBR.toLocaleDateString("pt-BR", {
        timeZone: "UTC",
      });

      return formattedDate;
    }

    return null;
  };

  const managedByBodyTemplate = (rowData: {
    pac_data: Date;
    advogado_id: number;
  }) => {
    if (updatedates !== undefined) {
      const filteredRecord = updatedates.filter(
        (item) => item.pac_data === rowData.pac_data,
        []
      );

      let attorneyName = "";
      const userLevel = filteredRecord[0].nivel_acesso;

      if (userLevel === "Administrador") {
        const filteredAdministrator = administrators.filter(
          (item) => item.administrador_id === filteredRecord[0].advogado_id,
          []
        );

        if (filteredAdministrator.length > 0) {
          attorneyName = filteredAdministrator[0]?.administrador_nome;
        }
      }
      if (userLevel === "Advogado") {
        const filteredAttorney = attorneys.filter(
          (item) => item.advogado_id === filteredRecord[0].advogado_id,
          []
        );

        if (filteredAttorney.length > 0) {
          attorneyName = filteredAttorney[0]?.advogado_nome;
        }
      }
      if (userLevel === "Assistente") {
        const filteredAssistant = assistants.filter(
          (item) => item.administrador_id === filteredRecord[0].advogado_id,
          []
        );

        if (filteredAssistant.length > 0) {
          attorneyName = filteredAssistant[0]?.administrador_nome;
        }
      }

      return attorneyName;
    }
    return "";
  };

  const notesBodyTemplate = (rowData: { pac_id: number; pac_obs: string }) => {
    if (updatedates !== undefined) {
      const filteredRecord = updatedates.filter(
        (item) => item.pac_id === rowData.pac_id
      );

      if (filteredRecord.length === 0) return null;

      return (
        // eslint-disable-next-line react/no-danger
        <div dangerouslySetInnerHTML={{ __html: filteredRecord[0].pac_obs }} />
      );
    }

    return null;
  };

  const dynamicColumns = columns.map((col) => {
    if (col.field === "pac_data") {
      return (
        <Column
          key={col.field}
          field={col.field}
          header={col.header}
          body={dateBodyTemplate}
          sortable={false}
          headerStyle={{ width: "100px" }}
        />
      );
    }
    if (col.field === "advogado_id") {
      return (
        <Column
          key={col.field}
          field={col.field}
          header={col.header}
          body={managedByBodyTemplate}
          sortable={false}
          headerStyle={{ width: "200px" }}
        />
      );
    }
    if (col.field === "pac_obs") {
      return (
        <Column
          key={col.field}
          field={col.field}
          header={col.header}
          body={notesBodyTemplate}
          sortable={false}
        />
      );
    }
    return (
      <Column key={col.field} field={col.field} header={col.header} sortable />
    );
  });

  const handleCreate = () => {
    history.push(`/lawsuit/agreementupdate/create?cod=${cod}&active=7`);
  };

  const hidedeleteUpdateDate = () => {
    setDeleteUpdateDateDialog(false);
  };

  const hidedeleteUpdateDatesDialog = () => {
    setDeleteUpdateDatesDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editUpdateDate = (rowData: any) => {
    history.push(
      `/lawsuit/agreementupdate/edit/${rowData.pac_id}?cod=${cod}&active=7`
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteUpdateDate = (
    updateDate: React.SetStateAction<{
      pac_id: null;
      pac_data: Date;
      pac_obs: string;
      advogado_id: number;
      nivel_acesso: string;
      and_arquivo: string;
    }>
  ) => {
    setUpdateDate(updateDate);
    setDeleteUpdateDateDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/agreementupdates/delete/${updatedate.pac_id}`);

    setDeleteUpdateDateDialog(false);

    const updatedRecords = updatedates.filter(
      (val) => val.pac_id !== updatedate.pac_id
    );
    setUpdateDates(updatedRecords);

    addToast({
      type: "success",
      title: "Cadastro excluído!",
      description: "O cadastro selecionado foi excluído com sucesso!",
    });
  };

  const handleFileOpen = (rowData: { and_arquivo: string }) => {
    (async () => {
      window.open(`${rowData.and_arquivo}`, "_blank");
    })();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => {
    if (loggedUserId === Number(rowData.advogado_id)) {
      return (
        <>
          <Button
            type="button"
            icon="pi pi-pencil"
            tooltip="Alterar cadastro"
            tooltipOptions={{ position: "left" }}
            className="p-button-rounded p-button-text p-button-plain p-mr-2"
            onClick={() => {
              editUpdateDate(rowData);
            }}
          />
          <Button
            type="button"
            icon="pi pi-trash"
            tooltip="Excluir cadastro"
            tooltipOptions={{ className: "red-tooltip", position: "left" }}
            className="p-button-rounded p-button-text p-button-plain"
            onClick={() => {
              confirmDeleteUpdateDate(rowData);
            }}
          />
          {rowData?.and_arquivo?.length > 2 ? (
            <Button
              type="button"
              icon="pi pi-file-pdf"
              className="p-button-rounded p-button-text p-button-plain"
              onClick={() => {
                handleFileOpen(rowData);
              }}
              tooltip="Abrir arquivo remotamente"
              tooltipOptions={{ position: "left" }}
            />
          ) : (
            ""
          )}
        </>
      );
    }

    return (
      <>
        {rowData?.and_arquivo?.length > 2 ? (
          <Button
            type="button"
            icon="pi pi-file-pdf"
            className="p-button-rounded p-button-text p-button-plain"
            onClick={() => {
              handleFileOpen(rowData);
            }}
            tooltip="Abrir arquivo remotamente"
            tooltipOptions={{ position: "left" }}
          />
        ) : (
          ""
        )}
      </>
    );
  };

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: "right" }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText
          type="search"
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Pesquisar na tabela"
        />
      </span>
    </div>
  );

  const paginatorLeft = (
    <Button type="button" icon="pi pi-refresh" className="p-button-text" />
  );
  const paginatorRight = (
    <Button type="button" icon="pi pi-cloud" className="p-button-text" />
  );

  const deleteUpdateDateFooter = (
    <>
      <Button
        type="button"
        label="Não"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hidedeleteUpdateDate}
      />
      <Button
        type="button"
        label="Sim"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteGroup}
      />
    </>
  );
  const deleteUpdateDatesDialogFooter = (
    <>
      <Button
        type="button"
        label="Não"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hidedeleteUpdateDatesDialog}
      />
    </>
  );

  return (
    <>
      <header>
        <div>
          <h1>Atualizações de Contratos</h1>
        </div>
      </header>

      <div className="datatable-responsive">
        <div className="card">
          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-updatedates table"
            id="table-updatedates"
            ref={dt}
            value={updatedates}
            editMode="row"
            dataKey="pac_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedUpdateDates}
            onSelectionChange={(e) => {
              const selUpdateDates = e.value as IUpdateDateProperties[];
              setSelectedUpdateDates(selUpdateDates);
            }}
            onRowDoubleClick={(e) => editUpdateDate(e.data)}
          >
            {dynamicColumns}
            <Column
              body={actionBodyTemplate}
              align="right"
              style={{ width: "160px" }}
            />
          </DataTable>
        </div>

        <div>
          <Dialog
            visible={deleteUpdateDate}
            style={{ width: "450px" }}
            header="Confirmação"
            modal
            footer={deleteUpdateDateFooter}
            onHide={hidedeleteUpdateDate}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle p-mr-3"
                style={{ fontSize: "2rem" }}
              />
              {updatedate && (
                <span>
                  Você tem certeza que deseja excluir
                  <br />
                  <br />
                  <b>{updatedate.pac_obs}</b>?
                </span>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={deleteUpdateDatesDialog}
            style={{ width: "450px" }}
            header="Confirmação"
            modal
            footer={deleteUpdateDatesDialogFooter}
            onHide={hidedeleteUpdateDatesDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle p-mr-3"
                style={{ fontSize: "2rem" }}
              />
              {updatedate && (
                <span>
                  Você tem certeza que deseja excluir os cadastros selecionados?
                </span>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </>
  );
};

export default AgreementUpdate;
